import { render, staticRenderFns } from "./ZaiYongTiAmount.vue?vue&type=template&id=0bdfdb7c&scoped=true&"
import script from "./ZaiYongTiAmount.vue?vue&type=script&lang=js&"
export * from "./ZaiYongTiAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdfdb7c",
  null
  
)

export default component.exports